module.exports = __webpack_public_path__ + "img/2.7d865f52.jpg";